"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KiirooGen2Vibe = void 0;
const Messages = __importStar(require("../../core/Messages"));
const Exceptions_1 = require("../../core/Exceptions");
const ButtplugDeviceProtocol_1 = require("../ButtplugDeviceProtocol");
class KiirooGen2VibeType {
    constructor() {
        this.Brand = "MagicMotion";
        this.Name = "Smart Mini Vibe";
        this.VibeCount = 1;
        this.VibeOrder = [0, 1, 2];
    }
}
class KiirooGen2Vibe extends ButtplugDeviceProtocol_1.ButtplugDeviceProtocol {
    constructor(aDeviceImpl) {
        super(`Kiiroo ${aDeviceImpl.Name}`, aDeviceImpl);
        this._devInfo = new KiirooGen2VibeType();
        this._hasRunCommand = false;
        this._vibratorSpeed = [0.0, 0.0, 0.0];
        this.HandleVibrateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (aMsg.Speeds.length < 1 || aMsg.Speeds.length > this._devInfo.VibeCount) {
                throw new Exceptions_1.ButtplugDeviceException(`Kiiroo Gen 2 Vibrator devices require VibrateCmd at most ` +
                    `${this._devInfo.VibeCount} speed commands, ${aMsg.Speeds.length} sent.`, aMsg.Id);
            }
            let changed = false;
            for (const cmd of aMsg.Speeds) {
                if (!(Math.abs(cmd.Speed - this._vibratorSpeed[cmd.Index]) > 0.001)) {
                    continue;
                }
                changed = true;
                this._vibratorSpeed[cmd.Index] = cmd.Speed;
            }
            if (!changed && this._hasRunCommand) {
                return new Messages.Ok(aMsg.Id);
            }
            const data = Buffer.from([
                this._vibratorSpeed[this._devInfo.VibeOrder[0]] * 100,
                this._vibratorSpeed[this._devInfo.VibeOrder[0]] * 100,
                this._vibratorSpeed[this._devInfo.VibeOrder[0]] * 100
            ]);
            this._hasRunCommand = true;
            yield this._device.WriteValue(data);
            return new Messages.Ok(aMsg.Id);
        });
        this.HandleStopDeviceCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            return yield this.HandleSingleMotorVibrateCmd(new Messages.SingleMotorVibrateCmd(0, aMsg.DeviceIndex, aMsg.Id));
        });
        this.HandleSingleMotorVibrateCmd = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            const speeds = [];
            for (let i = 0; i < this._devInfo.VibeCount; i++) {
                speeds.push(new Messages.SpeedSubcommand(i, aMsg.Speed));
            }
            return yield this.HandleVibrateCmd(new Messages.VibrateCmd(speeds, aMsg.DeviceIndex, aMsg.Id));
        });
        const tmpType = KiirooGen2Vibe.DevInfos.get(aDeviceImpl.Name);
        if (tmpType !== undefined) {
            this._devInfo = tmpType;
            this._name = `${this._devInfo.Brand} ${aDeviceImpl.Name}`;
        }
        this.MsgFuncs.set(Messages.StopDeviceCmd, this.HandleStopDeviceCmd);
        this.MsgFuncs.set(Messages.SingleMotorVibrateCmd, this.HandleSingleMotorVibrateCmd);
        this.MsgFuncs.set(Messages.VibrateCmd, this.HandleVibrateCmd);
    }
    get MessageSpecifications() {
        return {
            VibrateCmd: { FeatureCount: this._devInfo.VibeCount },
            SingleMotorVibrateCmd: {},
            StopDeviceCmd: {},
        };
    }
}
exports.KiirooGen2Vibe = KiirooGen2Vibe;
KiirooGen2Vibe.DevInfos = new Map([
    [
        "Pearl2",
        Object.assign(new KiirooGen2VibeType(), {
            Brand: "Kiiroo",
            VibeCount: 1,
            VibeOrder: [0, 1, 2],
        }),
    ],
    [
        "Fuse",
        Object.assign(new KiirooGen2VibeType(), {
            Brand: "OhMiBod",
            VibeCount: 2,
            VibeOrder: [1, 0, 2],
        }),
    ],
    [
        "Virtual Blowbot",
        Object.assign(new KiirooGen2VibeType(), {
            Brand: "PornHub",
            VibeCount: 3,
            VibeOrder: [0, 1, 2],
        }),
    ],
    [
        "Titan",
        Object.assign(new KiirooGen2VibeType(), {
            Brand: "Kiiroo",
            VibeCount: 3,
            VibeOrder: [0, 1, 2],
        }),
    ],
]);
//# sourceMappingURL=KiirooGen2Vibe.js.map